/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Smarts
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import SmartsAPI from './SmartsAPI'

// glass service
define([], function() {
	'use strict'

	class SmartsService extends SmartsAPI {

		/**
		 * When invoked as a service, glassContext will be passed into initalize
		 *  eg. .glassContext.getSvc('.SmartsService').then(smarts => {
		 */
		constructor() {
			super({
				logger: null,
				ajaxService: null
			})
		}

		/**
		 * initialize service, called by glass
		 * 
		 * @param  {object} glassContext
		 */
		initialize(glassContext) {
			this._logger = glassContext.getCoreSvc('.Logger')
			this._ajaxService = glassContext.getCoreSvc('.Ajax')
			return Promise.resolve()
		}
	}

	return SmartsService
})